import { isNil, noop, stubFalse } from 'lodash';
import { performanceMetricDataApi } from 'services/api/performanceMetricDataApi/performanceMetricDataApi';
import { getTraceMetricAttributes } from '../utils/getTraceMetricAttributes';
import { getTraceProcessingTime } from '../utils/getTraceProcessingTime';
import { SPAN_SCOPE } from './spanScope';

const FOUR_MINUTES_IN_NANO = 4 * 60 * 1_000_000_000;

export class CustomSpanMetricProcessor {
    constructor(normalizeSpanAttributes = stubFalse) {
        this.normalizeSpanAttributes = normalizeSpanAttributes;
        this.onStart = noop;
    }

    onEnd(span) {
        if (!SPAN_SCOPE[span.name] || !isNil(span.parentId) || !span.attributes) {
            return;
        }

        const transformedSpan = this.normalizeSpanAttributes(span);
        if (!transformedSpan) {
            return;
        }
        const processingTime = getTraceProcessingTime(span);
        if (processingTime > FOUR_MINUTES_IN_NANO) {
            console.error(`Span duration is more than 4 minutes: ${processingTime} ns`);
        }

        const metricAttributes = getTraceMetricAttributes(transformedSpan);

        performanceMetricDataApi.updatePerformanceMetricData({
            value: processingTime,
            labelData: metricAttributes,
        });
    }
}
